import React, { useState, useEffect } from "react";
import axios from "axios";
import { Phone, Search, Plus, Minus, Trash2, ShoppingCart, X, User, MapPin, Edit2, ChevronDown, ChevronUp } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PhonePage = ({ incomingCall, isCallerIDConnected, clearIncomingCall, persistentPhoneNumber, setPersistentPhoneNumber }) => {
  // Local state ile çalış - props değişince sync et
  const [phoneNumber, setPhoneNumber] = useState(persistentPhoneNumber || '');
  
  const phoneInputRef = React.useRef(null); // Input ref for focus
  const [customer, setCustomer] = useState(null);
  
  // localStorage'dan son çağrıyı kontrol et
  const checkLastIncomingCall = () => {
    try {
      // En son çağrının ID'sini al
      const latestCallId = localStorage.getItem('latestCallId');
      if (!latestCallId) {
        return;
      }
      
      // O çağrının verisini al
      const lastCallStr = localStorage.getItem(latestCallId);
      if (!lastCallStr) {
        return;
      }
      
      const lastCall = JSON.parse(lastCallStr);
      
      // 30 saniyeden eski çağrıları yoksay
      if (Date.now() - lastCall.timestamp > 30000) {
        console.log('[PhonePage] localStorage çağrısı çok eski, yoksayılıyor:', latestCallId);
        // Eski çağrıyı temizle
        localStorage.removeItem(latestCallId);
        localStorage.removeItem('latestCallId');
        return;
      }
      
      // Daha önce işlenmişse skip
      if (lastCall.processed) {
        console.log('[PhonePage] Çağrı daha önce işlenmiş, skip:', latestCallId);
        return;
      }
      
      console.log('📞 [PhonePage] localStorage\'dan YENİ çağrı bulundu:', lastCall.phoneNumber, 'ID:', latestCallId);
      
      // İşlendi olarak işaretle
      lastCall.processed = true;
      localStorage.setItem(latestCallId, JSON.stringify(lastCall));
      
      console.log('✅ [PhonePage] Çağrı işlendi olarak işaretlendi:', latestCallId);
      
      // Numarayı set et
      handleIncomingNumber(lastCall.phoneNumber);
      
      // Eski çağrıları temizle (30 saniyeden eski)
      cleanOldCalls();
      
    } catch (e) {
      console.error('[PhonePage] localStorage okuma hatası:', e);
    }
  };
  
  // Eski çağrıları temizle (localStorage şişmesin)
  const cleanOldCalls = () => {
    try {
      const now = Date.now();
      const keysToRemove = [];
      
      // Tüm localStorage key'lerini tara
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('call_')) {
          const callStr = localStorage.getItem(key);
          if (callStr) {
            const call = JSON.parse(callStr);
            // 30 saniyeden eski veya işlenmiş çağrıları sil
            if (now - call.timestamp > 30000 || call.processed) {
              keysToRemove.push(key);
            }
          }
        }
      }
      
      // Toplu silme
      keysToRemove.forEach(key => {
        localStorage.removeItem(key);
        console.log('[PhonePage] Eski çağrı silindi:', key);
      });
      
    } catch (e) {
      console.error('[PhonePage] cleanOldCalls hatası:', e);
    }
  };
  
  // Gelen numarayı işle
  const handleIncomingNumber = (number) => {
    console.log('🔥 [PhonePage] handleIncomingNumber ÇAĞRILDI:', number);
    touchInteraction();
    
    // ÖNCEKİ MÜŞTERİ BİLGİLERİNİ TEMİZLE!
    setCustomer(null);
    setNewCustomer({
      phone: number,
      first_name: "",
      last_name: "",
      address: ""
    });
    
    // Numarayı set et
    setPhoneNumber(number);
    setPersistentPhoneNumber(number);

    // Yeni bir çağrı/numara geldiğinde adres menüsü kapalı başlasın
    setSelectedAddress(null);
    setSelectedDeliveryAddressKey(null);
    setIsAddressesOpen(false);
    
    // Input'a focus
    setTimeout(() => {
      if (phoneInputRef.current) {
        phoneInputRef.current.focus();
        phoneInputRef.current.select();
        console.log('[PhonePage] Input focus + select yapıldı');
      }
    }, 100);
    
    // Müşteri ara (yeni numara için)
    setTimeout(() => {
      searchCustomerByPhone(number);
    }, 200);
  };
  
  // persistentPhoneNumber değişince local state'i güncelle
  useEffect(() => {
    if (persistentPhoneNumber && persistentPhoneNumber !== phoneNumber) {
      console.log('[PhonePage] persistentPhoneNumber DEĞİŞTİ:', persistentPhoneNumber);
      handleIncomingNumber(persistentPhoneNumber);
    }
  }, [persistentPhoneNumber]);
  
  // Custom event listener (üçüncü yol)
  useEffect(() => {
    const handleCallerIdEvent = (event) => {
      console.log('📡 [PhonePage] Custom event alındı:', event.detail);
      handleIncomingNumber(event.detail.phoneNumber);
    };
    
    window.addEventListener('callerIdIncoming', handleCallerIdEvent);
    
    return () => {
      window.removeEventListener('callerIdIncoming', handleCallerIdEvent);
    };
  }, []);
  const [categories, setCategories] = useState([]);
  const [lastInteractionAt, setLastInteractionAt] = useState(Date.now());


  const touchInteraction = () => {
    setLastInteractionAt(Date.now());
  };

  const [products, setProducts] = useState([]);
  const [extras, setExtras] = useState([]); // Extra ingredients list
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [cart, setCart] = useState([]);
  const [activeOrders, setActiveOrders] = useState([]);
  const [showNewCustomerModal, setShowNewCustomerModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false); // İlk ödeme (fiş için)
  const [showFinalPaymentModal, setShowFinalPaymentModal] = useState(false); // Gerçek ödeme
  const [selectedOrderForPayment, setSelectedOrderForPayment] = useState(null); // Ödeme yapılacak sipariş
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelOrderId, setCancelOrderId] = useState(null);
  const [cancelReason, setCancelReason] = useState("");
  const [lastCreatedOrder, setLastCreatedOrder] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState("nakit");
  // Sipariş oluşturma sırasında müşteri bilgisi kaybolmasın diye snapshot
  const [orderCustomerSnapshot, setOrderCustomerSnapshot] = useState(null);

  const [mealCardType, setMealCardType] = useState("sodexo");
  const [orderType, setOrderType] = useState("paket");
  const [showIncomingCallNotification, setShowIncomingCallNotification] = useState(false);
  const [newCustomer, setNewCustomer] = useState({
    phone: "",
    first_name: "",
    last_name: "",
    address: ""
  });
  
  // Adres yönetimi state'leri
  const [selectedAddress, setSelectedAddress] = useState(null); // Seçili adres (UI list item)
  const [selectedDeliveryAddressKey, setSelectedDeliveryAddressKey] = useState(null); // "main" veya address.id
  const [isAddressesOpen, setIsAddressesOpen] = useState(false); // Adresler accordion
  const [showAddressModal, setShowAddressModal] = useState(false);


  // Telefon sekmesi adres mantığı:
  // - Ana adres: customer.address (silinemez, her zaman 1 adres gibi davranır)
  // - Ek adresler: customer.addresses (max 2)
  // - 1 adres varsa otomatik seçili; 2-3 adres varsa seçim zorunlu
  const getDeliveryAddressOptions = () => {
    const options = [];

    // Ana adres: customer.address varsa onu kullan.
    // Bazı eski kayıtlarda customer.address boş olabilir; bu durumda customer.addresses[0] ana adres gibi davranır.
    const all = Array.isArray(customer?.addresses) ? customer.addresses : [];

    if (customer?.address) {
      options.push({
        key: "main",
        id: "main",
        label: "Ana Adres",
        address: customer.address,
        is_default: true,
        is_main: true,
        source: "customer",
      });

      // Ek adresler
      all.slice(0, 2).forEach((a) => {
        options.push({
          key: a.id,
          id: a.id,
          label: a.label,
          address: a.address,
          first_name: a.first_name || null,
          last_name: a.last_name || null,
          is_default: !!a.is_default,
          is_main: false,
          source: "addresses",
        });
      });
    } else if (all.length > 0) {
      // Legacy: ilk ek adresi ana gibi göster
      const main = all[0];
      options.push({
        key: "main",
        id: "main",
        label: main.label || "Ana Adres",
        address: main.address,
        first_name: main.first_name || null,
        last_name: main.last_name || null,
        is_default: true,
        is_main: true,
        source: "addresses",
      });

      // Geri kalanlar ek adres
      all.slice(1, 3).forEach((a) => {
        options.push({
          key: a.id,
          id: a.id,
          label: a.label,
          address: a.address,
          first_name: a.first_name || null,
          last_name: a.last_name || null,
          is_default: !!a.is_default,
          is_main: false,
          source: "addresses",
        });
      });
    }

    return options;
  };


  const getExtraAddressCount = () => getDeliveryAddressOptions().filter(o => !o.is_main).length;

  // Müşteri değişince adres seçim mantığını uygula
  useEffect(() => {
    if (!customer) return;

    const opts = getDeliveryAddressOptions();

    if (opts.length === 1) {
      // Tek adres varsa otomatik seç
      setSelectedAddress(opts[0]);
      setSelectedDeliveryAddressKey(opts[0].key);
    } else {
      // 2-3 adres varsa seçimi sıfırla (zorunlu seçim)
      setSelectedAddress(null);
      setSelectedDeliveryAddressKey(null);
    }
  }, [customer]);

  // Adres menüsü sadece 11 haneli telefon numarası geldiğinde görünsün
  const shouldShowAddressSection = phoneNumber && phoneNumber.length === 11 && !!customer;


  // Bekleyen sipariş düzenleme
  const [isEditingOrder, setIsEditingOrder] = useState(false);
  const [editingOrder, setEditingOrder] = useState(null);

  // 3 dakika işlem yoksa otomatik temizle (sipariş eklenmediyse numara takılı kalmasın)
  useEffect(() => {
    const interval = setInterval(() => {
      const idleMs = Date.now() - lastInteractionAt;
      if (idleMs < 180000) return;

      // Sepet boş ve ödeme/düzenleme modunda değilsek otomatik temizle
      if (cart.length === 0 && !showPaymentModal && !showFinalPaymentModal && !isEditingOrder && phoneNumber) {
        console.log('[PhonePage] 3dk idle -> otomatik clearSearch');
        clearSearch();
      }
    }, 5000);


    return () => clearInterval(interval);
  }, [lastInteractionAt, cart.length, showPaymentModal, showFinalPaymentModal, isEditingOrder, phoneNumber]);

  const [editingAddress, setEditingAddress] = useState(null);
  const [newAddress, setNewAddress] = useState({
    label: "",
    address: "",
    is_default: false,
    first_name: "",
    last_name: "",
  });
  
  // Ingredient customization modal states
  const [showIngredientModal, setShowIngredientModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [editingCartIndex, setEditingCartIndex] = useState(null);
  const [removedIngredients, setRemovedIngredients] = useState([]);
  const [addedIngredients, setAddedIngredients] = useState([]);
  const [customQuantity, setCustomQuantity] = useState(1);
  const [specialNote, setSpecialNote] = useState("");
  const [selectedSize, setSelectedSize] = useState(null); // For size selection
  const [isExtrasOpen, setIsExtrasOpen] = useState(false); // Ekstra malzeme accordion
  const [isIngredientsOpen, setIsIngredientsOpen] = useState(false); // Çıkarılacak malzeme accordion

  useEffect(() => {
    loadCategories();
    loadProducts();
    loadActiveOrders();
    loadExtras(); // Load extra ingredients
    
    // Component mount olduğunda localStorage'dan son çağrıyı kontrol et
    console.log('[PhonePage] Component mount - localStorage kontrol ediliyor...');
    checkLastIncomingCall();
    
    // Her 10 saniyede bir aktif siparişleri yenile
    const interval = setInterval(loadActiveOrders, 10000);
    
    // Her 1 saniyede bir localStorage'ı kontrol et (daha hızlı polling)
    const pollingInterval = setInterval(() => {
      checkLastIncomingCall();
    }, 1000);
    
    return () => {
      clearInterval(interval);
      clearInterval(pollingInterval);
    };
  }, []);

  // Global WebSocket'ten gelen çağrıları dinle
  useEffect(() => {
    if (incomingCall && incomingCall.phoneNumber) {
      console.log('📞 [PhonePage] Gelen çağrı alındı:', incomingCall.phoneNumber);

      // Numarayı işle (tek merkez)
      handleIncomingNumber(incomingCall.phoneNumber);

      // Bildirim göster
      setShowIncomingCallNotification(true);
      setTimeout(() => {
        setShowIncomingCallNotification(false);
      }, 5000);

      // Otomatik müşteri ara
      searchCustomerByPhone(incomingCall.phoneNumber);

      // Çağrıyı temizle
      if (clearIncomingCall) {
        clearIncomingCall();
      }
    }
  }, [incomingCall]);

  const loadCategories = async () => {
    try {
      const response = await axios.get(`${API}/categories`);
      setCategories(response.data);
      // İlk kategoriyi otomatik seç
      if (response.data.length > 0 && !selectedCategory) {
        setSelectedCategory(response.data[0].id);
      }
    } catch (error) {
      console.error("Kategoriler yüklenirken hata:", error);
    }
  };

  const loadProducts = async () => {
    try {
      const response = await axios.get(`${API}/products`);
      setProducts(response.data);
    } catch (error) {
      console.error("Ürünler yüklenirken hata:", error);
    }
  };

  const loadExtras = async () => {
    try {
      const response = await axios.get(`${API}/extras`);
      setExtras(response.data);
    } catch (error) {
      console.error("Ekstra malzemeler yüklenirken hata:", error);
    }
  };

  const loadActiveOrders = async () => {
    try {
      const response = await axios.get(`${API}/orders`);
      // Telefon sekmesi: Sadece phone kaynaklı paket/gel-al ve ödenmemiş siparişler
      const phoneOrders = response.data.filter(
        o => (o.order_type === "paket" || o.order_type === "gel-al") &&
             o.payment_status === "ödenmedi" &&
             o.order_status !== "iptal" &&
             (o.order_source === "phone" || (!o.order_source && !!o.customer_phone))
      );

      setActiveOrders(phoneOrders);
    } catch (error) {
      console.error("Siparişler yüklenirken hata:", error);
    }
  };

  const searchCustomer = async () => {
    touchInteraction();
    if (!phoneNumber || phoneNumber.length < 10) {
      alert("Lütfen geçerli bir telefon numarası girin (10 haneli)");
      return;
    }

    // Önce müşteriyi temizle
    setCustomer(null);

    try {
      const response = await axios.get(`${API}/customers/search/${phoneNumber}`);
      if (response.data.found && response.data.customer) {
        setCustomer(response.data.customer);
        // Kayıtlı müşteri formu
        setNewCustomer({
          phone: response.data.customer.phone,
          first_name: response.data.customer.first_name,
          last_name: response.data.customer.last_name,
          address: response.data.customer.address || ""
        });
        console.log("Müşteri bulundu:", response.data.customer);
      } else {
        // Müşteri bulunamadı - formu telefon ile hazırla
        setCustomer(null);
        setNewCustomer({
          phone: phoneNumber,
          first_name: "",
          last_name: "",
          address: ""
        });
        console.log("Müşteri kayıtlı değil, sipariş alındıktan sonra kayıt edilecek");
        alert("Müşteri kayıtlı değil. Sipariş alındıktan sonra müşteri kaydı yapılacak.");
      }
    } catch (error) {
      console.error("Müşteri arama hatası:", error);
      alert("Müşteri aranırken hata oluştu");
    }
  };

  const searchCustomerByPhone = async (phone) => {
    /**
     * WebSocket'ten gelen numara için otomatik arama
     * Modal AÇMAZ - sadece müşteriyi bulur veya bulamaz
     */
    console.log('[PhonePage] searchCustomerByPhone çağrıldı:', phone);
    
    // Önce müşteriyi temizle
    setCustomer(null);
    
    try {
      const response = await axios.get(`${API}/customers/search/${phone}`);
      if (response.data.found && response.data.customer) {
        setCustomer(response.data.customer);
        console.log("✅ Müşteri otomatik bulundu:", response.data.customer);
        // newCustomer formunu kayıtlı müşteri bilgileriyle doldur
        setNewCustomer({
          phone: response.data.customer.phone,
          first_name: response.data.customer.first_name,
          last_name: response.data.customer.last_name,
          address: response.data.customer.address || ""
        });
      } else {
        // Müşteri bulunamadı - formu sadece telefon numarasıyla hazırla
        setCustomer(null);
        setNewCustomer({
          phone: phone,
          first_name: "",
          last_name: "",
          address: ""
        });
        console.log("ℹ️ Yeni müşteri - sipariş sonrası kayıt edilecek");
      }
    } catch (error) {
      console.error("❌ Müşteri arama hatası:", error);
      // Hata durumunda da formu hazırla
      setCustomer(null);
      setNewCustomer({
        phone: phone,
        first_name: "",
        last_name: "",
        address: ""
      });
    }
  };

  const playNotificationSound = () => {
    /**
     * Tarayıcı ses bildirimi
     */
    try {
      // Basit bip sesi
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      
      oscillator.frequency.value = 800;
      oscillator.type = 'sine';
      
      gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);
      
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.5);
    } catch (e) {
      console.log('Ses bildirimi desteklenmiyor');
    }
  };

  const createCustomer = async () => {
    if (!newCustomer.first_name || !newCustomer.last_name || !newCustomer.phone) {
      alert("Lütfen tüm alanları doldurun");
      return;
    }

    try {
      const response = await axios.post(`${API}/customers`, newCustomer);
      setCustomer(response.data);
      setShowNewCustomerModal(false);
      // Müşteri kaydedildikten sonra ödeme modalını aç
      setShowPaymentModal(true);
    } catch (error) {
      console.error("Müşteri oluşturma hatası:", error);
      alert("Müşteri oluşturulurken hata oluştu");
    }
  };

  // Ingredient customization modal functions
  const openIngredientModal = (product, cartIndex = null) => {
    touchInteraction();
    setSelectedProduct(product);
    setEditingCartIndex(cartIndex);
    setIsExtrasOpen(false); // Accordion kapalı başlasın
    setIsIngredientsOpen(false); // Çıkarılacak malzeme accordion kapalı
    
    if (cartIndex !== null) {
      // Editing existing item
      const item = cart[cartIndex];
      setRemovedIngredients(item.removed_ingredients || []);
      setAddedIngredients(item.added_ingredients || []);
      setCustomQuantity(item.quantity);
      setSpecialNote(item.special_note || "");
      setSelectedSize(item.size || (product.sizes && product.sizes.length > 0 ? product.sizes[0].name : null));
    } else {
      // New item
      setRemovedIngredients([]);
      setAddedIngredients([]);
      setCustomQuantity(1);
      setSpecialNote("");
      setSelectedSize(product.sizes && product.sizes.length > 0 ? product.sizes[0].name : null);
    }
    
    setShowIngredientModal(true);
  };

  const toggleRemovedIngredient = (ingredient) => {
    if (removedIngredients.includes(ingredient)) {
      setRemovedIngredients(removedIngredients.filter(i => i !== ingredient));
    } else {
      setRemovedIngredients([...removedIngredients, ingredient]);
    }
  };

  const toggleAddedIngredient = (extraId) => {
    if (addedIngredients.includes(extraId)) {
      setAddedIngredients(addedIngredients.filter(i => i !== extraId));
    } else {
      setAddedIngredients([...addedIngredients, extraId]);
    }
  };

  const addCustomizedToCart = () => {
    // Calculate price with size and extras
    let finalPrice = selectedProduct.price;
    
    // Size price adjustment
    if (selectedProduct.sizes && selectedSize) {
      const sizeObj = selectedProduct.sizes.find(s => s.name === selectedSize);
      if (sizeObj) {
        finalPrice = sizeObj.price;
      }
    }
    
    // Add extras price
    addedIngredients.forEach(extraId => {
      const extra = extras.find(e => e.id === extraId);
      if (extra) {
        if (extra.size_prices && selectedSize) {
          // Boyut bazlı fiyat
          const sizePrice = extra.size_prices.find(sp => sp.size === selectedSize.toLowerCase());
          finalPrice += sizePrice ? sizePrice.price : extra.price;
        } else {
          finalPrice += extra.price;
        }
      }
    });
    
    // Prepare added ingredients with prices
    const addedIngredientsDetails = addedIngredients.map(id => {
      const extra = extras.find(e => e.id === id);
      if (!extra) return null;
      
      let price = extra.price;
      if (extra.size_prices && selectedSize) {
        const sizePrice = extra.size_prices.find(sp => sp.size === selectedSize.toLowerCase());
        price = sizePrice ? sizePrice.price : extra.price;
      }
      
      return {
        name: extra.name,
        price: price
      };
    }).filter(Boolean);
    
    const newItem = {
      product_id: selectedProduct.id,
      product_name: selectedProduct.name,
      price: finalPrice,
      quantity: customQuantity,
      size: selectedSize,
      removed_ingredients: removedIngredients,
      added_ingredients: addedIngredients.map(id => extras.find(e => e.id === id)?.name).filter(Boolean),
      added_ingredients_details: addedIngredientsDetails, // NEW: with prices
      special_note: specialNote
    };
    
    if (editingCartIndex !== null) {
      // Update existing item
      const updatedCart = [...cart];
      updatedCart[editingCartIndex] = newItem;
      setCart(updatedCart);
    } else {
      // Add new item
      setCart([...cart, newItem]);
    }
    
    setShowIngredientModal(false);
  };

  const addToCart = (product) => {
    touchInteraction();
    // Malzeme veya boyut seçimi varsa modal aç
    if ((product.ingredients && product.ingredients.length > 0) || 
        (product.extra_ids && product.extra_ids.length > 0) ||
        (product.sizes && product.sizes.length > 0)) {
      openIngredientModal(product);
    } else {
      // Basit ürün, direkt ekle
      const existingItem = cart.find(item => item.product_id === product.id);
      if (existingItem) {
        setCart(cart.map(item =>
          item.product_id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        ));
      } else {
        setCart([...cart, {
          product_id: product.id,
          product_name: product.name,
          quantity: 1,
          price: product.price,
          removed_ingredients: [],
          added_ingredients: [],
          special_note: null
        }]);
      }
    }
  };

  const updateQuantity = (index, delta) => {
    // Index bazlı güncelleme
    setCart(cart.map((item, idx) => {
      if (idx === index) {
        const newQuantity = item.quantity + delta;
        if (newQuantity <= 0) {
          return null; // Adet 0 olursa sil
        }
        return { ...item, quantity: newQuantity };
      }
      return item;
    }).filter(Boolean)); // null olanları temizle
  };

  const removeFromCart = (productId, index = null) => {
    if (index !== null) {
      // Remove specific item by index
      setCart(cart.filter((_, idx) => idx !== index));
    } else {
      // Remove by product_id (legacy)
      setCart(cart.filter(item => item.product_id !== productId));
    }
  };

  const calculateTotal = () => {
    return cart.reduce((sum, item) => sum + (item.price * item.quantity), 0).toFixed(2);
  };

  // Tarih farkını hesapla
  const getTimeDifference = (dateString) => {
    const orderDate = new Date(dateString);
    const now = new Date();
    const diffMs = now - orderDate;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);
    
    if (diffDays > 0) {
      return `${diffDays} gün önce`;
    } else if (diffHours > 0) {
      return `${diffHours} saat önce`;
    } else if (diffMins > 0) {
      return `${diffMins} dakika önce`;
    } else {
      return 'Az önce';
    }
  };

  // Geçen süreyi hesapla (dakika ve saat)
  const getElapsedTime = (dateString) => {
    const orderDate = new Date(dateString);
    const now = new Date();
    const diffMs = now - orderDate;
    const diffMins = Math.floor(diffMs / 60000);
    const hours = Math.floor(diffMins / 60);
    const mins = diffMins % 60;
    
    if (hours > 0) {
      return `${hours}s ${mins}dk`;
    } else {
      return `${mins}dk`;
    }
  };

  // Adres yönetimi fonksiyonları
  const openAddressModal = (address = null) => {
    touchInteraction();
    if (!customer) return;

    // Ana adres (customer.address) UI listesinde var ve buradan düzenlenebilir
    if (address && address.is_main) {
      setEditingAddress({ id: "main", is_main: true });
      setNewAddress({
        label: "Ana Adres",
        address: customer?.address || "",
        is_default: true,
        first_name: customer?.first_name || "",
        last_name: customer?.last_name || "",
      });
      setIsAddressesOpen(true);
      setShowAddressModal(true);
      return;
    }

    if (address) {
      setEditingAddress(address);
      setNewAddress({
        label: address.label,
        address: address.address,
        is_default: address.is_default,
        first_name: address.first_name || customer?.first_name || "",
        last_name: address.last_name || customer?.last_name || "",
      });
    } else {
      // Yeni ek adres
      const extraCount = getExtraAddressCount();
      if (extraCount >= 2) {
        alert("Maksimum 2 ek adres ekleyebilirsiniz");
        return;
      }

      setEditingAddress(null);
      setNewAddress({
        label: "",
        address: "",
        is_default: false,
        first_name: customer?.first_name || "",
        last_name: customer?.last_name || "",
      });
    }
    setIsAddressesOpen(true); // Modal açılıyorsa adres listesi de açık olsun
    setShowAddressModal(true);
  };

  const saveAddress = async () => {
    if (!customer) return;

    if (!newAddress.label || !newAddress.address) {
      alert("Lütfen adres etiketi ve adres bilgisini girin");
      return;
    }

    try {
      if (editingAddress?.is_main) {
        // Ana adresi güncelle: /customers/{id}
        await axios.put(`${API}/customers/${customer.id}`, {
          address: newAddress.address,
        });
      } else if (editingAddress) {
        // Ek adres güncelle
        await axios.put(`${API}/customers/${customer.id}/addresses/${editingAddress.id}`, {
          label: newAddress.label,
          address: newAddress.address,
          is_default: newAddress.is_default,
          first_name: newAddress.first_name,
          last_name: newAddress.last_name,
        });
      } else {
        // Yeni ek adres ekle
        const currentCount = getExtraAddressCount();
        if (currentCount >= 2) {
          alert("Maksimum 2 ek adres ekleyebilirsiniz");
          return;
        }
        await axios.post(`${API}/customers/${customer.id}/addresses`, {
          label: newAddress.label,
          address: newAddress.address,
          is_default: newAddress.is_default,
          first_name: newAddress.first_name,
          last_name: newAddress.last_name,
        });
      }

      // Müşteriyi yeniden yükle
      const response = await axios.get(`${API}/customers/${customer.id}`);
      setCustomer(response.data);
      setIsAddressesOpen(true); // Kaydettikten sonra kullanıcı sonucu görsün

      setShowAddressModal(false);
      setNewAddress({ label: "", address: "", is_default: false, first_name: customer?.first_name || "", last_name: customer?.last_name || "" });
      setEditingAddress(null);
    } catch (error) {
      console.error("Adres kaydetme hatası:", error);
      alert("Adres kaydedilemedi: " + (error.response?.data?.detail || error.message));
    }
  };

  const deleteAddress = async (addressId) => {
    if (!customer) return;

    // En az 1 adres her zaman olmalı:
    // - Ana adres (customer.address) silinemez
    // - Ek adreslerde ise son ek adresi silmeye izin ver (ana adres yine kalır)

    if (!window.confirm("Bu adresi silmek istediğinize emin misiniz?")) {
      return;
    }

    try {
      await axios.delete(`${API}/customers/${customer.id}/addresses/${addressId}`);

      // Müşteriyi yeniden yükle
      const response = await axios.get(`${API}/customers/${customer.id}`);
      setCustomer(response.data);
      setIsAddressesOpen(true); // Silme sonrası kullanıcı güncel listeyi görsün

      // Eğer seçili adres silindiyse, seçimi kaldır
      if (selectedDeliveryAddressKey === addressId) {
        setSelectedAddress(null);
        setSelectedDeliveryAddressKey(null);
      }
    } catch (error) {
      console.error("Adres silme hatası:", error);
      alert("Adres silinemedi: " + (error.response?.data?.detail || error.message));
    }
  };

  // Müşterinin son siparişini bul
  const getLastOrderDate = () => {
    if (!customer) return null;
    
    // activeOrders'dan müşterinin siparişlerini bul
    const customerOrders = activeOrders.filter(o => o.customer_id === customer.id);
    if (customerOrders.length === 0) return null;
    
    // En son siparişi bul
    const sortedOrders = [...customerOrders].sort((a, b) => 
      new Date(b.created_at) - new Date(a.created_at)
    );
    
    return sortedOrders[0]?.created_at;
  };

  const createOrder = async (orderTypeParam) => {
    touchInteraction();
    // Edit modundayken yeni sipariş oluşturma yerine update kullanılmalı
    if (isEditingOrder) {
      alert("Düzenleme modundayken yeni sipariş oluşturamazsınız. 'Kaydet & Yazdır' kullanın.");
      return;
    }
    if (cart.length === 0) {
      alert("Sepet boş, lütfen ürün ekleyin");
      return;
    }

    setOrderType(orderTypeParam);

    // Müşteri kayıtlı değilse önce kayıt modalını aç
    if (!customer) {
      setNewCustomer({ ...newCustomer, phone: phoneNumber });
      setShowNewCustomerModal(true);
      return;
    }

    // Kayıtlı müşteride adres seçimi: 2-3 adres varsa seçim zorunlu

    const options = getDeliveryAddressOptions();
    if (options.length >= 2 && !selectedDeliveryAddressKey) {
      setIsAddressesOpen(true);
      alert("Siparişe devam etmek için lütfen teslimat adresi seçin");
      return;
    }

    // Müşteri varsa direkt ödeme modalına git
    // Snapshot al (sipariş kaydedilirken müşteri state'i temizlenirse fişte Misafir görünmesin)
    setOrderCustomerSnapshot(customer ? { ...customer } : null);
    setShowPaymentModal(true);
  };

  const completeOrder = async () => {
    try {
      // localStorage çağrı kaydını da temizle (refresh sonrası numara tekrar gelmesin)
      try {
        const latestCallId = localStorage.getItem('latestCallId');
        if (latestCallId) {
          localStorage.removeItem(latestCallId);
          localStorage.removeItem('latestCallId');
        }
      } catch (e) {
        // ignore
      }

      const finalPaymentMethod = paymentMethod === "yemek-karti" 
        ? `Yemek Kartı (${mealCardType.charAt(0).toUpperCase() + mealCardType.slice(1)})`
        : paymentMethod === "kredi-karti" 
        ? "Kredi Kartı" 
        : "Nakit";

      // Clean cart items for backend (remove added_ingredients_details)
      const cleanedItems = cart.map(item => {
        const { added_ingredients_details, ...cleanItem } = item;
        return cleanItem;
      });

      // Adres seçimi kuralları (sadece kayıtlı müşteri):
      // - Ana adres customer.address her zaman var kabul edilir
      // - Ek adresler customer.addresses (max 2)
      // - 1 adres varsa otomatik seçili (selectedAddress set edilir)
      // - 2-3 adres varsa, seçim yapılmadan sipariş onaylanmaz
      const options = getDeliveryAddressOptions();

      if (options.length >= 2 && !selectedDeliveryAddressKey) {
        setIsAddressesOpen(true);
        alert("Lütfen teslimat adresi seçin");
        return;
      }

      let deliveryAddress = "";
      if (selectedDeliveryAddressKey) {
        const picked = options.find((o) => o.key === selectedDeliveryAddressKey);
        if (picked) {
          // Ana adreste label'ı tekrar yazmaya gerek yok
          deliveryAddress = picked.key === "main" ? picked.address : `${picked.label}: ${picked.address}`;
        }
      }

      // Fallback: tek adres varsa otomatik seçili olmalı ama emniyet için
      if (!deliveryAddress && options.length === 1) {
        const only = options[0];
        deliveryAddress = only.key === "main" ? only.address : `${only.label}: ${only.address}`;
      }

      const usedCustomer = customer || orderCustomerSnapshot;

      const orderData = {
        order_source: "phone",
        customer_id: usedCustomer?.id || null,
        customer_name: usedCustomer ? `${usedCustomer.first_name} ${usedCustomer.last_name}` : "Misafir",
        customer_phone: usedCustomer?.phone || phoneNumber,
        delivery_contact_name: (
          selectedAddress?.first_name ||
          selectedAddress?.last_name
        )
          ? `${(selectedAddress?.first_name || '').trim()} ${(selectedAddress?.last_name || '').trim()}`.trim()
          : usedCustomer
            ? `${(usedCustomer.first_name || '').trim()} ${(usedCustomer.last_name || '').trim()}`.trim()
            : null,
        customer_address: deliveryAddress,
        items: cleanedItems, // Send cleaned items
        total: parseFloat(calculateTotal()),
        order_type: orderType,
        payment_status: "ödenmedi", // İlk ödeme, sadece fiş için
        payment_method: finalPaymentMethod // Fiş üzerinde gösterilecek
      };

      const response = await axios.post(`${API}/orders`, orderData);
      
      // Yazdırma için cart'taki detayları koru
      const orderWithDetails = {
        ...response.data,
        customer_name: response.data.customer_name || orderData.customer_name,
        customer_phone: response.data.customer_phone || orderData.customer_phone,
        customer_address: response.data.customer_address || orderData.customer_address,
        items: cart.map((cartItem, idx) => ({
          ...response.data.items[idx],
          added_ingredients_details: cartItem.added_ingredients_details
        }))
      };
      
      // Sipariş oluşturuldu, yazdırma modalını göster
      setLastCreatedOrder(orderWithDetails);
      setShowPaymentModal(false);
      setShowPrintModal(true);
      
      // Sepeti ve müşteri bilgilerini temizle (yeni sipariş için hazır ol)
      setCart([]);
      setPaymentMethod("nakit");
      setMealCardType("sodexo");
      setPhoneNumber("");
      setCustomer(null);
      setSelectedCategory(null);
      
      loadActiveOrders();
    } catch (error) {
      console.error("Sipariş oluşturma hatası:", error);
      console.error("Error details:", error.response?.data);
      alert("Sipariş oluşturulurken hata oluştu: " + (error.response?.data?.detail || error.message));
    }
  };

  const handlePrintReceipt = () => {
    const printContent = document.getElementById('phone-print-content');
    if (!printContent) {
      alert("Yazdırma içeriği bulunamadı");
      return;
    }

    const originalDisplay = printContent.style.display;
    printContent.style.display = 'block';
    
    const printWindow = window.open('', '_blank');
    printWindow.document.write('<html><head><title>Sipariş Fişi</title>');
    printWindow.document.write('<style>');
    printWindow.document.write('body { font-family: monospace; margin: 0; padding: 0; }');
    printWindow.document.write('* { box-sizing: border-box; }');
    printWindow.document.write('</style>');
    printWindow.document.write('</head><body>');
    printWindow.document.write(printContent.innerHTML);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
    
    printContent.style.display = originalDisplay;
    setShowPrintModal(false);
    
    setTimeout(() => {
      setPhoneNumber("");
      setCustomer(null);
      setCart([]);
      setSelectedCategory(null);
      setLastCreatedOrder(null);
    }, 500);
  };

  const closePrintModal = () => {
    setShowPrintModal(false);
    setLastCreatedOrder(null);
    
    // Modal kapatıldığında da sıfırla
    setPhoneNumber("");
    setCustomer(null);
    setCart([]);
    setSelectedCategory(null);
    
    // Aktif siparişleri yenile
    loadActiveOrders();
  };

  // Ödendi & Kapat butonu - Gerçek ödeme modalını açar
  const openFinalPayment = (order) => {
    setSelectedOrderForPayment(order);
    setPaymentMethod("nakit"); // Reset payment method
    setShowFinalPaymentModal(true);
  };

  // Gerçek ödemeyi tamamla - Ciroya ekle
  const completeFinalPayment = async () => {
    try {
      const finalPaymentMethod = paymentMethod === "yemek-karti" 
        ? `Yemek Kartı (${mealCardType.charAt(0).toUpperCase() + mealCardType.slice(1)})`
        : paymentMethod === "kredi-karti" 
        ? "Kredi Kartı" 
        : "Nakit";

      await axios.put(`${API}/orders/${selectedOrderForPayment.id}`, {
        payment_status: "ödendi",
        payment_method: finalPaymentMethod // Gerçek ödeme yöntemi ciroya eklenir
      });
      
      setShowFinalPaymentModal(false);
      setSelectedOrderForPayment(null);
      loadActiveOrders();
    } catch (error) {
      console.error("Ödeme hatası:", error);
      alert("Ödeme işlenirken hata oluştu");
    }
  };

  // Tekrar yazdır
  const reprintOrder = (order) => {
    setLastCreatedOrder(order);
    setShowPrintModal(true);
  };

  const handleCancelOrder = (orderId) => {
    setCancelOrderId(orderId);
    setCancelReason("");
    setShowCancelModal(true);
  };

  const confirmCancelOrder = async () => {
    if (!cancelReason.trim()) {
      alert("Lütfen iptal nedenini yazın");
      return;
    }

    try {
      await axios.put(`${API}/orders/${cancelOrderId}`, {
        payment_status: "iptal",
        special_note: `İptal Nedeni: ${cancelReason}`
      });
      
      alert("Sipariş iptal edildi");
      setShowCancelModal(false);
      setCancelOrderId(null);
      setCancelReason("");
      loadActiveOrders();
    } catch (error) {
      console.error("Sipariş iptal hatası:", error);
      alert("Sipariş iptal edilirken hata oluştu");
    }
  };

  const clearSearch = () => {
    console.log('[PhonePage] clearSearch çağrıldı - TAM TEMİZLİK');
    touchInteraction();
    setPhoneNumber("");
    setPersistentPhoneNumber(""); // Global state'i de temizle
    setCustomer(null);
    setSelectedAddress(null);
    setSelectedDeliveryAddressKey(null);
    setIsAddressesOpen(false);

    setCart([]);
    // Yeni müşteri formunu da temizle
    setNewCustomer({
      phone: "",
      first_name: "",
      last_name: "",
      address: ""
    });
  };

  const openEditOrder = (order) => {
    if (order.payment_status !== "ödenmedi" || order.order_status !== "bekliyor") {
      alert("Sadece bekleyen sipariş düzenlenebilir");
      return;
    }

    setIsEditingOrder(true);
    setEditingOrder(order);

    // Sepete mevcut sipariş kalemlerini yükle
    const items = Array.isArray(order.items) ? order.items : [];
    setCart(items.map(it => ({
      product_id: it.product_id,
      product_name: it.product_name,
      price: it.price,
      quantity: it.quantity,
      size: it.size || null,
      removed_ingredients: it.removed_ingredients || [],
      added_ingredients: it.added_ingredients || [],
      added_ingredients_details: it.added_ingredients_details || [],
      special_note: it.special_note || ""
    })));

    // Ürün modalı state reset
    setShowIngredientModal(false);
  };

  const saveEditedOrder = async () => {
    if (!editingOrder) return;

    try {
      const cleanedItems = cart.map(item => {
        const { added_ingredients_details, ...cleanItem } = item;
        return cleanItem;
      });

      const response = await axios.put(`${API}/orders/${editingOrder.id}/pending`, {
        items: cleanedItems,
      });

      const orderWithDetails = {
        ...response.data,
        customer_name: response.data.customer_name || editingOrder.customer_name,
        customer_phone: response.data.customer_phone || editingOrder.customer_phone,
        customer_address: response.data.customer_address || editingOrder.customer_address,
        items: cart.map((cartItem, idx) => ({
          ...response.data.items[idx],
          added_ingredients_details: cartItem.added_ingredients_details,
        })),
      };

      setLastCreatedOrder(orderWithDetails);
      setShowPrintModal(true);

      setIsEditingOrder(false);
      setEditingOrder(null);
      setCart([]);

      loadActiveOrders();
    } catch (error) {
      console.error("Sipariş düzenleme hatası:", error);
      alert("Sipariş düzenlenirken hata oluştu: " + (error.response?.data?.detail || error.message));
    }
  };

  const cancelEditOrder = () => {
    if (!window.confirm("Düzenlemeyi iptal etmek istiyor musunuz?")) return;
    setIsEditingOrder(false);
    setEditingOrder(null);
    setCart([]);
  };


  const filteredProducts = selectedCategory
    ? products.filter(p => p.category_id === selectedCategory)
    : products;

  return (
    <div className="flex h-screen bg-gray-100" data-testid="phone-page">
      {/* Gelen Çağrı Bildirimi */}
      {showIncomingCallNotification && (
        <div className="fixed top-4 right-4 z-50 bg-green-500 text-white px-6 py-4 rounded-lg shadow-lg animate-bounce">
          <div className="flex items-center space-x-3">
            <Phone className="animate-pulse" size={24} />
            <div>
              <div className="font-bold">📞 Gelen Çağrı!</div>
              <div className="text-sm">{incomingCall?.phoneNumber}</div>
            </div>
          </div>
        </div>
      )}

      {/* Sol: Telefon Arama ve Ürünler */}
      <div className="flex-1 p-6 overflow-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold text-gray-800">📞 Telefon Siparişleri</h1>
        </div>

        {isEditingOrder && (
          <div className="mb-4 bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <div className="flex items-start justify-between gap-4">
              <p className="text-sm text-yellow-800">
                Toplam (güncel sepet): <span className="font-bold">{calculateTotal()} ₺</span>
              </p>
              <div className="flex gap-2">
                <button
                  onClick={cancelEditOrder}
                  className="px-4 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium"
                >
                  İptal
                </button>
                <button
                  onClick={saveEditedOrder}
                  className="px-4 py-2 rounded-lg bg-orange-600 hover:bg-orange-700 text-white font-bold"
                >
                  Kaydet & Yazdır
                </button>
              </div>
            </div>
          </div>
        )}


        {/* Telefon Numarası Arama */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <h2 className="text-xl font-bold text-gray-800 mb-4">Müşteri Ara</h2>
          <div className="flex space-x-3">
            <div className="flex-1 relative">
              <Phone className="absolute left-3 top-3 text-gray-400" size={20} />
              <input
                ref={phoneInputRef}
                type="tel"
                placeholder="Telefon numarası (05xxxxxxxxx)"
                value={phoneNumber || ''}
                onChange={(e) => {
                  // Sadece rakamları al
                  let value = e.target.value.replace(/\D/g, "");
                  console.log('[PhonePage] Input onChange:', value);
                  setPhoneNumber(value);
                  // Global state'i de güncelle
                  setPersistentPhoneNumber(value);
                  
                  // 11 haneye ulaştığında otomatik ara
                  if (value.length === 11) {
                    console.log('[PhonePage] 11 hane tamamlandı, otomatik arama başlatılıyor...');
                    setTimeout(() => {
                      searchCustomerByPhone(value);
                    }, 100);
                  }
                }}
                onKeyPress={(e) => e.key === "Enter" && searchCustomer()}
                maxLength={11}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button
              onClick={searchCustomer}
              className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium flex items-center space-x-2"
            >
              <Search size={20} />
              <span>Ara</span>
            </button>
            {customer && (
              <button
                onClick={clearSearch}
                className="px-4 py-3 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
              >
                <X size={20} />
              </button>
            )}
          </div>

          {/* Müşteri Bilgileri veya Durum */}
          {customer ? (
            <div className="mt-4 space-y-3">
              <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
                <div className="flex items-start space-x-3">
                  <User className="text-green-600 mt-1" size={24} />
                  <div className="flex-1">
                    <h3 className="text-lg font-bold text-gray-800">
                      {customer.first_name} {customer.last_name}
                    </h3>
                    <p className="text-sm text-gray-600 flex items-center mt-1">
                      <Phone size={14} className="mr-2" />
                      {customer.phone}
                    </p>
                    {/* Son Sipariş Bilgisi */}
                    {getLastOrderDate() && (
                      <p className="text-sm text-blue-600 font-medium mt-2">
                        🕒 Son sipariş: {getTimeDifference(getLastOrderDate())}
                      </p>
                    )}

                    {/* Ana adres (sadece tek adres varsa burada göster) */}
                    {customer.address && getDeliveryAddressOptions().length === 1 && (
                      <p className="text-sm text-gray-700 mt-2">
                        <span className="font-semibold">📍 Ana Adres:</span> {customer.address}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {/* Adres Yönetimi */}
              {shouldShowAddressSection && (
                <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
                  <div className="flex items-center justify-between mb-3">
                    <button
                      type="button"
                      onClick={() => setIsAddressesOpen((v) => !v)}
                      className="flex items-center gap-2 font-semibold text-gray-800 hover:text-gray-900"
                      title={isAddressesOpen ? "Adresleri gizle" : "Adresleri göster"}
                    >
                      <MapPin size={18} className="text-blue-600" />
                      <span>Teslimat Adresleri</span>
                      <span className="text-xs font-medium text-gray-600">
                        ({getDeliveryAddressOptions().length}/3)
                      </span>
                      {isAddressesOpen ? (
                        <ChevronUp size={16} className="text-gray-500" />
                      ) : (
                        <ChevronDown size={16} className="text-gray-500" />
                      )}
                    </button>

                  {isAddressesOpen && customer && getExtraAddressCount() < 2 && (
                    <button
                      onClick={() => openAddressModal()}
                      className="text-sm bg-blue-600 text-white px-3 py-1 rounded-lg hover:bg-blue-700 flex items-center"
                    >
                      <Plus size={14} className="mr-1" />
                      Yeni Adres
                    </button>
                  )}
                </div>

                {/* Kapalıyken kısa özet */}
                {!isAddressesOpen && (
                  <div className="text-sm text-gray-700 bg-white/70 border border-blue-200 rounded-lg px-3 py-2">
                    {selectedAddress ? (
                      <span>
                        Seçili: <span className="font-semibold">{selectedAddress.label}</span>
                      </span>
                    ) : getDeliveryAddressOptions().length >= 2 ? (
                      <span className="text-red-600 font-medium">Adres seçimi gerekli</span>
                    ) : (
                      <span className="text-gray-500">Adresleri görmek için açın</span>
                    )}
                  </div>
                )}

                {/* Adres Listesi */}
                {isAddressesOpen && getDeliveryAddressOptions().length > 0 ? (
                  <div className="space-y-2">
                    {getDeliveryAddressOptions().map((addr) => (
                      <div
                        key={addr.key}
                        className={`p-3 rounded-lg border-2 cursor-pointer transition ${
                          selectedDeliveryAddressKey === addr.key
                            ? 'border-blue-600 bg-blue-100'
                            : 'border-gray-200 bg-white hover:border-blue-300'
                        }`}
                        onClick={() => {
                          setSelectedAddress(addr);
                          setSelectedDeliveryAddressKey(addr.key);
                        }}
                      >
                        <div className="flex items-start justify-between">
                          <div className="flex-1">
                            <div className="flex items-center gap-2">
                              <span className="font-semibold text-sm text-gray-800">{addr.label}</span>
                              {addr.is_main && (
                                <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded">
                                  Ana
                                </span>
                              )}
                              {!addr.is_main && addr.is_default && (
                                <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded">
                                  Varsayılan
                                </span>
                              )}
                            </div>
                            <p className="text-sm text-gray-600 mt-1">{addr.address}</p>
                          </div>

                          {/* Ana adres düzenlenebilir; ek adres düzenlenebilir + silinebilir */}
                          <div className="flex items-center gap-1 ml-2">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                openAddressModal(addr);
                              }}
                              className="p-1 text-blue-600 hover:bg-blue-100 rounded"
                              title="Düzenle"
                            >
                              <Edit2 size={14} />
                            </button>

                            {!addr.is_main && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  deleteAddress(addr.id);
                                }}
                                className="p-1 text-red-600 hover:bg-red-100 rounded"
                                title="Sil"
                              >
                                <Trash2 size={14} />
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : isAddressesOpen ? (
                  <div className="text-sm text-gray-500 text-center py-3">
                    Henüz adres eklenmemiş
                  </div>
                ) : null}
                </div>
              )}
            </div>
          ) : phoneNumber && phoneNumber.length >= 10 ? (
            <div className="mt-4 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
              <div className="flex items-start space-x-3">
                <User className="text-yellow-600 mt-1" size={24} />
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-gray-800">
                    Yeni Müşteri
                  </h3>
                  <p className="text-sm text-gray-600">
                    Bu numara kayıtlı değil. Sipariş alındıktan sonra müşteri kaydı yapılacak.
                  </p>
                </div>
              </div>
            </div>
          ) : null}
        </div>

        {/* Ürünler - Her zaman göster */}
        <>
          {/* Kategoriler */}
          <div className="bg-white rounded-lg shadow-md p-4 mb-6">
            <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2">
              {categories.map(cat => (
                <button
                  key={cat.id}
                  onClick={() => setSelectedCategory(cat.id)}
                  className={`px-3 py-2 rounded-lg font-medium text-sm transition ${
                    selectedCategory === cat.id
                        ? "bg-orange-600 text-white shadow-md"
                        : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                    }`}
                  >
                    {cat.name}
                  </button>
                ))}
              </div>
            </div>

            {/* Ürün Listesi */}
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {filteredProducts.map(product => (
                <div
                  key={product.id}
                  onClick={() => addToCart(product)}
                  className="bg-white rounded-lg shadow-md p-4 cursor-pointer hover:shadow-xl transition hover:scale-105"
                >
                  <h3 className="font-bold text-gray-800 mb-2">{product.name}</h3>
                  <p className="text-orange-600 font-bold text-lg">{product.price} ₺</p>
                  {product.description && (
                    <p className="text-xs text-gray-500 mt-2 line-clamp-2">{product.description}</p>
                  )}
                </div>
              ))}
            </div>
          </>
      </div>

      {/* Sağ: Sepet ve Aktif Siparişler */}
      <div className="w-96 bg-white shadow-xl p-6 overflow-auto">
        {/* Sepet - Daha büyük alan */}
        <div className="mb-6" style={{ minHeight: '55vh' }}>
          <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
            <ShoppingCart size={24} className="mr-2" />
            Sepet ({cart.length})
          </h2>

          {cart.length === 0 ? (
            <p className="text-gray-500 text-center py-8">Sepet boş</p>
          ) : (
            <>
              <div className="space-y-3 mb-4">
                {cart.map((item, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-3">
                    <div className="flex justify-between items-start mb-2">
                      <div className="flex-1">
                        <h4 className="font-semibold text-gray-800">{item.product_name}</h4>
                        {item.size && (
                          <div className="text-xs text-purple-600 font-medium mt-1">
                            🍕 {item.size}
                          </div>
                        )}
                        {item.removed_ingredients && item.removed_ingredients.length > 0 && (
                          <div className="text-xs text-red-600 mt-1">
                            ❌ {item.removed_ingredients.join(", ")}
                          </div>
                        )}
                        {item.added_ingredients && item.added_ingredients.length > 0 && (
                          <div className="text-xs text-green-600 mt-1">
                            ➕ {item.added_ingredients.join(", ")}
                          </div>
                        )}
                        {item.special_note && (
                          <div className="text-xs text-gray-600 mt-1 italic">
                            📝 {item.special_note}
                          </div>
                        )}
                      </div>

                      <div className="flex space-x-2">
                        <button
                          onClick={() => {
                            const product = products.find((p) => p.id === item.product_id);
                            if (product) openIngredientModal(product, index);
                          }}
                          className="text-blue-500 hover:text-blue-700"
                        >


                          <Edit2 size={16} />
                        </button>
                        <button
                          onClick={() => removeFromCart(item.product_id, index)}
                          className="text-red-500 hover:text-red-700"
                        >
                          <Trash2 size={16} />
                        </button>
                      </div>
                      </div>
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-2">
                          <button
                            onClick={() => updateQuantity(index, -1)}
                            className="w-8 h-8 bg-gray-200 rounded-full hover:bg-gray-300"
                          >
                            <Minus size={16} className="mx-auto" />
                          </button>
                          <span className="w-8 text-center font-semibold">{item.quantity}</span>
                          <button
                            onClick={() => updateQuantity(index, 1)}
                            className="w-8 h-8 bg-gray-200 rounded-full hover:bg-gray-300"
                          >
                            <Plus size={16} className="mx-auto" />
                          </button>
                        </div>
                        <span className="font-bold text-orange-600">
                          {(item.price * item.quantity).toFixed(2)} ₺
                        </span>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Toplam */}
                <div className="border-t pt-4 mb-4">
                  <div className="flex justify-between items-center text-xl font-bold">
                    <span>Toplam:</span>
                    <span className="text-orange-600">{calculateTotal()} ₺</span>
                  </div>
                </div>

                {/* Sipariş Butonları */}
                {!isEditingOrder && (
                  <div className="space-y-2">
                    <button
                      onClick={() => createOrder("paket")}
                      className="w-full py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 font-bold"
                    >
                      📦 Paket Sipariş Ver
                    </button>
                    <button
                      onClick={() => createOrder("gel-al")}
                      className="w-full py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-bold"
                    >
                      🏃 Gel-Al Sipariş Ver
                    </button>
                  </div>
                )}
              </>
            )}
          </div>

        {/* Aktif Siparişler - Daha küçük alan */}
        <div className="border-t pt-6" style={{ maxHeight: '35vh', overflowY: 'auto' }}>
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Aktif Siparişler ({activeOrders.length})
          </h2>

          {activeOrders.length === 0 ? (
            <p className="text-gray-500 text-center py-8">Aktif sipariş yok</p>
          ) : (
            <div className="space-y-3">
              {activeOrders.map(order => (
                <div key={order.id} className="border border-gray-300 rounded-lg p-4 bg-gray-50">
                  <div className="flex justify-between items-start mb-2">
                    <div>
                      <div className="flex items-start justify-between gap-2">
                        <h4 className="font-bold text-gray-800">{order.customer_name || "Misafir"}</h4>
                        {order.payment_status === "ödenmedi" && order.order_status === "bekliyor" && (
                          <button
                            onClick={() => openEditOrder(order)}
                            className="p-1.5 rounded-md hover:bg-orange-100 text-orange-600"
                            title="Siparişi Düzenle"
                          >
                            <Edit2 size={16} />
                          </button>
                        )}
                      </div>
                      <p className="text-xs text-gray-600">
                        {order.order_type === "paket" ? "📦 Paket" : "🏃 Gel-Al"}
                      </p>
                      <p className="text-xs text-gray-500 mt-1">
                        {new Date(order.created_at).toLocaleString("tr-TR")}
                      </p>
                      {/* Geçen Süre */}
                      <p className="text-xs font-bold text-red-600 mt-1">
                        ⏱️ Geçen: {getElapsedTime(order.created_at)}
                      </p>
                    </div>
                    <span className="font-bold text-orange-600">{order.total} ₺</span>
                  </div>
                  <div className="text-sm text-gray-700 mb-3">
                    {order.items.map((item, idx) => (
                      <div key={idx}>• {item.quantity}x {item.product_name}</div>
                    ))}
                  </div>
                  <div className="space-y-2">
                    <button
                      onClick={() => openFinalPayment(order)}
                      className="w-full py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 text-sm font-medium"
                    >
                      ✓ Ödendi & Kapat
                    </button>
                    <button
                      onClick={() => reprintOrder(order)}
                      className="w-full py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-medium"
                    >
                      🖨️ Tekrar Yazdır
                    </button>
                    <button
                      onClick={() => handleCancelOrder(order.id)}
                      className="w-full py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 text-sm font-medium"
                    >
                      ✕ Sipariş İptal
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Ödeme Yöntemi Modal */}
      {showPaymentModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-[500px] max-h-[90vh] flex flex-col">
            {/* Header - Sabit */}
            <div className="p-6 border-b">
              <h2 className="text-2xl font-bold text-gray-800">
                💳 Ödeme Yöntemi Seçin
              </h2>
              <p className="text-sm text-gray-600 mt-2">
                {orderType === "paket" ? "Paket" : "Gel-Al"} siparişi için ödeme yöntemini seçin
              </p>
            </div>

            {/* İçerik - Kaydırmalı */}
            <div className="flex-1 overflow-y-auto p-6">
              {/* Ödeme Yöntemleri */}
                    {/* Düzenle butonu aktif sipariş kartında gösteriliyor */}

              <div className="space-y-3 mb-6">
              <button
                onClick={() => setPaymentMethod("nakit")}
                className={`w-full p-4 border-2 rounded-lg text-left transition ${
                  paymentMethod === "nakit"
                    ? "border-green-500 bg-green-50"
                    : "border-gray-300 hover:border-green-300"
                }`}
              >
                <div className="flex items-center">
                  <div className={`w-5 h-5 rounded-full border-2 mr-3 flex items-center justify-center ${
                    paymentMethod === "nakit" ? "border-green-500" : "border-gray-300"
                  }`}>
                    {paymentMethod === "nakit" && (
                      <div className="w-3 h-3 rounded-full bg-green-500"></div>
                    )}
                  </div>
                  <div>
                    <div className="font-bold text-gray-800">💵 Nakit</div>
                    <div className="text-xs text-gray-500">Nakit ödeme</div>
                  </div>
                </div>
              </button>

              <button
                onClick={() => setPaymentMethod("kredi-karti")}
                className={`w-full p-4 border-2 rounded-lg text-left transition ${
                  paymentMethod === "kredi-karti"
                    ? "border-blue-500 bg-blue-50"
                    : "border-gray-300 hover:border-blue-300"
                }`}
              >
                <div className="flex items-center">
                  <div className={`w-5 h-5 rounded-full border-2 mr-3 flex items-center justify-center ${
                    paymentMethod === "kredi-karti" ? "border-blue-500" : "border-gray-300"
                  }`}>
                    {paymentMethod === "kredi-karti" && (
                      <div className="w-3 h-3 rounded-full bg-blue-500"></div>
                    )}
                  </div>
                  <div>
                    <div className="font-bold text-gray-800">💳 Kredi Kartı</div>
                    <div className="text-xs text-gray-500">Kredi/banka kartı ile ödeme</div>
                  </div>
                </div>
              </button>

              <button
                onClick={() => setPaymentMethod("yemek-karti")}
                className={`w-full p-4 border-2 rounded-lg text-left transition ${
                  paymentMethod === "yemek-karti"
                    ? "border-orange-500 bg-orange-50"
                    : "border-gray-300 hover:border-orange-300"
                }`}
              >
                <div className="flex items-center">
                  <div className={`w-5 h-5 rounded-full border-2 mr-3 flex items-center justify-center ${
                    paymentMethod === "yemek-karti" ? "border-orange-500" : "border-gray-300"
                  }`}>
                    {paymentMethod === "yemek-karti" && (
                      <div className="w-3 h-3 rounded-full bg-orange-500"></div>
                    )}
                  </div>
                  <div>
                    <div className="font-bold text-gray-800">🍽️ Yemek Kartı</div>
                    <div className="text-xs text-gray-500">Ticket, Sodexo, Multinet vb.</div>
                  </div>
                </div>
              </button>
            </div>

            {/* Yemek Kartı Seçenekleri */}
            {paymentMethod === "yemek-karti" && (
              <div className="mb-6 p-4 bg-orange-50 border border-orange-200 rounded-lg">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Yemek Kartı Türü:
                </label>
                <div className="grid grid-cols-2 gap-2">
                  <button
                    onClick={() => setMealCardType("sodexo")}
                    className={`p-2 rounded-lg border-2 text-sm font-medium ${
                      mealCardType === "sodexo"
                        ? "border-orange-500 bg-white text-orange-700"
                        : "border-gray-300 bg-white text-gray-700 hover:border-orange-300"
                    }`}
                  >
                    Sodexo
                  </button>
                  <button
                    onClick={() => setMealCardType("ticket")}
                    className={`p-2 rounded-lg border-2 text-sm font-medium ${
                      mealCardType === "ticket"
                        ? "border-orange-500 bg-white text-orange-700"
                        : "border-gray-300 bg-white text-gray-700 hover:border-orange-300"
                    }`}
                  >
                    Ticket
                  </button>
                  <button
                    onClick={() => setMealCardType("multinet")}
                    className={`p-2 rounded-lg border-2 text-sm font-medium ${
                      mealCardType === "multinet"
                        ? "border-orange-500 bg-white text-orange-700"
                        : "border-gray-300 bg-white text-gray-700 hover:border-orange-300"
                    }`}
                  >
                    Multinet
                  </button>
                  <button
                    onClick={() => setMealCardType("metropol")}
                    className={`p-2 rounded-lg border-2 text-sm font-medium ${
                      mealCardType === "metropol"
                        ? "border-orange-500 bg-white text-orange-700"
                        : "border-gray-300 bg-white text-gray-700 hover:border-orange-300"
                    }`}
                  >
                    Metropol
                  </button>
                </div>
              </div>
            )}

              {/* Toplam */}
              <div className="border-t pt-4 mb-6">
                <div className="flex justify-between items-center text-xl font-bold">
                  <span>Toplam:</span>
                  <span className="text-orange-600">{calculateTotal()} ₺</span>
                </div>
              </div>
            </div>

            {/* Butonlar - Sabit */}
            <div className="p-6 border-t flex space-x-3">
              <button
                onClick={() => setShowPaymentModal(false)}
                className="flex-1 py-3 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400 font-medium"
              >
                İptal
              </button>
              <button
                onClick={completeOrder}
                className="flex-1 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 font-bold"
              >
                ✓ Siparişi Tamamla
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Yazdırma Modal */}
      {showPrintModal && lastCreatedOrder && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-[500px] p-6">
            <h2 className="text-2xl font-bold text-green-600 mb-4 text-center">
              ✓ Sipariş Oluşturuldu!
            </h2>
            
            {/* Sipariş Özeti */}
            <div className="bg-gray-50 rounded-lg p-4 mb-6">
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-600">Müşteri:</span>
                  <span className="font-semibold">{lastCreatedOrder.customer_name}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Tip:</span>
                  <span className="font-semibold">
                    {lastCreatedOrder.order_type === "paket" ? "📦 Paket" : "🏃 Gel-Al"}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Ödeme:</span>
                  <span className="font-semibold">{lastCreatedOrder.payment_method}</span>
                </div>
                <div className="flex justify-between border-t pt-2 mt-2">
                  <span className="text-gray-800 font-bold">Toplam:</span>
                  <span className="text-orange-600 font-bold text-lg">
                    {lastCreatedOrder.total} ₺
                  </span>
                </div>
              </div>
            </div>

            <p className="text-center text-gray-600 mb-6">
              Siparişi yazdırmak ister misiniz?
            </p>

            {/* Gizli yazdırma içeriği */}
            <div id="phone-print-content" style={{ display: 'none' }}>
              <div style={{ 
                fontFamily: 'monospace', 
                width: '300px', 
                margin: '0 auto', 
                padding: '15px',
                fontSize: '12px', // 11px → 12px
                lineHeight: '1.4'
              }}>
                {/* Header */}
                <div style={{ textAlign: 'center', borderBottom: '2px double black', paddingBottom: '8px', marginBottom: '10px' }}>
                  <h2 style={{ fontSize: '19px', fontWeight: 'bold', margin: '0 0 4px 0' }}>🍕 VERONA PIZZA</h2>
                  <p style={{ fontSize: '13px', fontWeight: 'bold', margin: '3px 0' }}>TELEFON SİPARİŞİ</p>
                  <p style={{ fontSize: '10px', margin: '2px 0' }}>{new Date().toLocaleString("tr-TR")}</p>
                </div>

                {/* Customer Info */}
                <div style={{ marginBottom: '10px', paddingBottom: '8px', borderBottom: '1px solid black' }}>
                  <p style={{ margin: '3px 0', fontSize: '12px' }}>
                    <b>MÜŞTERİ:</b> {lastCreatedOrder.delivery_contact_name || lastCreatedOrder.customer_name}
                  </p>
                  <p style={{ margin: '3px 0', fontSize: '12px' }}>
                    <b>TELEFON:</b> {lastCreatedOrder.customer_phone}
                  </p>
                  {lastCreatedOrder.customer_address && (
                    <p style={{ margin: '3px 0', fontSize: '12px' }}>
                      <b>ADRES:</b> {lastCreatedOrder.customer_address}
                    </p>
                  )}
                  <p style={{ margin: '3px 0', fontSize: '12px' }}>
                    <b>TİP:</b> {lastCreatedOrder.order_type === "paket" ? "📦 Paket" : "🏃 Gel-Al"}
                  </p>
                </div>

                {/* Items */}
                <div style={{ marginBottom: '10px' }}>
                  <h3 style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '8px', textAlign: 'center', borderBottom: '2px solid black', paddingBottom: '4px' }}>
                    SİPARİŞ DETAYI
                  </h3>
                  
                  {lastCreatedOrder.items.map((item, idx) => (
                    <div key={idx} style={{ marginBottom: '10px', paddingBottom: '8px', borderBottom: '1px dashed black' }}>
                      {/* Product Name with Adet and Size */}
                      <p style={{ fontSize: '13px', margin: '2px 0', fontWeight: 'bold' }}>
                        {item.quantity} Adet - {item.product_name}
                        {item.size && <span style={{ fontWeight: 'normal' }}> ({item.size})</span>}
                      </p>

                      {/* Removed Ingredients */}
                      {item.removed_ingredients && item.removed_ingredients.length > 0 && (
                        <p style={{ fontSize: '11px', margin: '4px 0 2px 10px', lineHeight: '1.3' }}>
                          <b>❌ ÇIKARILACAK:</b> {item.removed_ingredients.join(", ")}
                        </p>
                      )}

                      {/* Added Ingredients */}
                      {item.added_ingredients_details && item.added_ingredients_details.length > 0 && (
                        <p style={{ fontSize: '11px', margin: '4px 0 2px 10px', lineHeight: '1.3' }}>
                          <b>➕ EKSTRA:</b><br />
                          {item.added_ingredients_details.map((extra, i) => (
                            <span key={i}>
                              &nbsp;&nbsp;• {extra.name} (+{extra.price.toFixed(2)}₺){i < item.added_ingredients_details.length - 1 ? <br /> : ''}
                            </span>
                          ))}
                        </p>
                      )}
                      {!item.added_ingredients_details && item.added_ingredients && item.added_ingredients.length > 0 && (
                        <p style={{ fontSize: '11px', margin: '4px 0 2px 10px', lineHeight: '1.3' }}>
                          <b>➕ EKSTRA:</b> {item.added_ingredients.join(", ")}
                        </p>
                      )}

                      {/* Special Note */}
                      {item.special_note && (
                        <p style={{ fontSize: '11px', margin: '4px 0 2px 10px', fontStyle: 'italic', lineHeight: '1.3' }}>
                          <b>📝 NOT:</b> {item.special_note}
                        </p>
                      )}

                      {/* Price */}
                      <p style={{ textAlign: 'right', fontSize: '12px', fontWeight: 'bold', marginTop: '4px' }}>
                        {(item.price * item.quantity).toFixed(2)} ₺
                      </p>
                    </div>
                  ))}
                </div>

                {/* Total */}
                <div style={{ borderTop: '3px double black', paddingTop: '8px', marginBottom: '10px' }}>
                  <p style={{ fontSize: '15px', fontWeight: 'bold', margin: '5px 0', textAlign: 'center' }}>
                    TOPLAM: {lastCreatedOrder.total} ₺
                  </p>
                  <p style={{ fontSize: '12px', marginTop: '5px', textAlign: 'center' }}>
                    <b>ÖDEME:</b> {lastCreatedOrder.payment_method}
                  </p>
                </div>

                {/* Footer */}
                <div style={{ textAlign: 'center', paddingTop: '8px', borderTop: '1px dashed black', fontSize: '11px' }}>
                  <p style={{ fontSize: '13px', fontWeight: 'bold', margin: '5px 0' }}>
                    🍕 AFİYET OLSUN! 🍕
                  </p>
                  <p style={{ fontSize: '10px', margin: '3px 0' }}>
                    Verona Pizza
                  </p>
                </div>
              </div>
            </div>

            {/* Butonlar */}
            <div className="flex space-x-3">
              <button
                onClick={closePrintModal}
                className="flex-1 py-3 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400 font-medium"
              >
                Kapat
              </button>
              <button
                onClick={handlePrintReceipt}
                className="flex-1 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-bold"
              >
                🖨️ Yazdır
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Sipariş İptal Modal */}
      {showCancelModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-[500px] p-6">
            <h2 className="text-2xl font-bold text-red-600 mb-4">
              ⚠️ Sipariş İptal
            </h2>
            <p className="text-sm text-gray-600 mb-4">
              Bu siparişi iptal etmek istediğinizden emin misiniz? Lütfen iptal nedenini yazın.
            </p>

            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                İptal Nedeni *
              </label>
              <textarea
                value={cancelReason}
                onChange={(e) => setCancelReason(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                rows={4}
                placeholder="Örn: Müşteri fikir değiştirdi, Yanlış sipariş girildi, vb..."
              />
            </div>

            {/* Butonlar */}
            <div className="flex space-x-3">
              <button
                onClick={() => setShowCancelModal(false)}
                className="flex-1 py-3 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400 font-medium"
              >
                Vazgeç
              </button>
              <button
                onClick={confirmCancelOrder}
                className="flex-1 py-3 bg-red-600 text-white rounded-lg hover:bg-red-700 font-bold"
              >
                ✓ İptal Et
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Yeni Müşteri Modal */}
      {showNewCustomerModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-[500px] p-6">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Yeni Müşteri Kaydı</h2>
            <p className="text-sm text-gray-600 mb-4">
              Bu telefon numarası sistemde kayıtlı değil. Yeni müşteri oluşturun.
            </p>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Telefon *
                </label>
                <input
                  type="tel"
                  value={newCustomer.phone}
                  onChange={(e) => setNewCustomer({ ...newCustomer, phone: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  readOnly
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Ad *
                </label>
                <input
                  type="text"
                  value={newCustomer.first_name}
                  onChange={(e) => setNewCustomer({ ...newCustomer, first_name: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  placeholder="Ahmet"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Soyad *
                </label>
                <input
                  type="text"
                  value={newCustomer.last_name}
                  onChange={(e) => setNewCustomer({ ...newCustomer, last_name: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  placeholder="Yılmaz"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Adres (Opsiyonel)
                </label>
                <textarea
                  value={newCustomer.address}
                  onChange={(e) => setNewCustomer({ ...newCustomer, address: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  rows={3}
                  placeholder="Teslimat adresi..."
                />
              </div>
            </div>

            <div className="flex space-x-3 mt-6">
              <button
                onClick={() => setShowNewCustomerModal(false)}
                className="flex-1 py-3 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400 font-medium"
              >
                İptal
              </button>
              <button
                onClick={createCustomer}
                className="flex-1 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-bold"
              >
                Müşteri Kaydet
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Malzeme Özelleştirme Modal */}
      {showIngredientModal && selectedProduct && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[70] p-4">
          <div className="bg-white rounded-lg w-[600px] max-h-[90vh] flex flex-col">
            <div className="p-6 border-b">
              <h2 className="text-2xl font-bold text-gray-800">
                🍕 {selectedProduct.name} - Özelleştir
              </h2>
            </div>

            <div className="p-6 overflow-y-auto flex-1">
              {/* Boyut Seçimi */}
              {selectedProduct.sizes && selectedProduct.sizes.length > 0 && (
                <div className="mb-6">
                  <h3 className="font-bold mb-2 text-gray-700">Boyut Seçin</h3>
                  <div className="grid grid-cols-3 gap-2">
                    {selectedProduct.sizes.map((size) => (
                      <button
                        key={size.name}
                        onClick={() => setSelectedSize(size.name)}
                        className={`px-4 py-3 rounded-lg border-2 transition ${
                          selectedSize === size.name
                            ? "border-orange-500 bg-orange-50 text-orange-800"
                            : "border-gray-200 hover:border-gray-300"
                        }`}
                      >
                        <div className="font-semibold">{size.name}</div>
                        <div className="text-sm text-orange-600">{size.price} ₺</div>
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {/* Malzeme Çıkarma - Accordion */}
              {selectedProduct.ingredients && selectedProduct.ingredients.length > 0 && (
                <div className="mb-6 border-2 border-gray-200 rounded-lg overflow-hidden">
                  <button
                    onClick={() => setIsIngredientsOpen(!isIngredientsOpen)}
                    className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 transition"
                  >
                    <div className="flex items-center space-x-2">
                      <h3 className="font-bold text-gray-700">Malzeme Çıkar</h3>
                      {removedIngredients.length > 0 && (
                        <span className="bg-red-500 text-white text-xs px-2 py-1 rounded-full">
                          {removedIngredients.length} çıkarıldı
                        </span>
                      )}
                    </div>
                    {isIngredientsOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </button>
                  
                  {isIngredientsOpen && (
                    <div className="p-4 bg-white">
                      <div className="grid grid-cols-2 gap-2">
                        {selectedProduct.ingredients.map((ingredient) => (
                          <button
                            key={ingredient}
                            onClick={() => toggleRemovedIngredient(ingredient)}
                            className={`px-3 py-2 rounded-lg border-2 text-sm transition ${
                              removedIngredients.includes(ingredient)
                                ? "border-red-500 bg-red-50 text-red-800"
                                : "border-gray-200 hover:border-gray-300"
                            }`}
                          >
                            {removedIngredients.includes(ingredient) && "❌ "}
                            {ingredient}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Ekstra Malzeme - Accordion */}
              {selectedProduct.extra_ids && selectedProduct.extra_ids.length > 0 && (
                <div className="mb-6 border-2 border-gray-200 rounded-lg overflow-hidden">
                  <button
                    onClick={() => setIsExtrasOpen(!isExtrasOpen)}
                    className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 transition"
                  >
                    <div className="flex items-center space-x-2">
                      <h3 className="font-bold text-gray-700">Ekstra Malzeme Ekle</h3>
                      {addedIngredients.length > 0 && (
                        <span className="bg-green-500 text-white text-xs px-2 py-1 rounded-full">
                          {addedIngredients.length} seçili
                        </span>
                      )}
                    </div>
                    {isExtrasOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                  </button>
                  
                  {isExtrasOpen && (
                    <div className="p-4 bg-white">
                      <div className="grid grid-cols-2 gap-2">
                        {extras
                          .filter((extra) => selectedProduct.extra_ids.includes(extra.id))
                          .map((extra) => {
                            let priceText = "";
                            if (extra.size_prices && selectedSize) {
                              const sizePrice = extra.size_prices.find(
                                (sp) => sp.size === selectedSize.toLowerCase()
                              );
                              priceText = sizePrice ? `+${sizePrice.price}₺` : `+${extra.price}₺`;
                            } else {
                              priceText = `+${extra.price}₺`;
                            }

                            return (
                              <button
                                key={extra.id}
                                onClick={() => toggleAddedIngredient(extra.id)}
                                className={`px-3 py-2 rounded-lg border-2 text-sm transition ${
                                  addedIngredients.includes(extra.id)
                                    ? "border-green-500 bg-green-50 text-green-800"
                                    : "border-gray-200 hover:border-gray-300"
                                }`}
                              >
                                {addedIngredients.includes(extra.id) && "✓ "}
                                {extra.name} <span className="text-xs">({priceText})</span>
                              </button>
                            );
                          })}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Özel Not */}
              <div className="mb-6">
                <h3 className="font-bold mb-2 text-gray-700">Özel Not (Opsiyonel)</h3>
                <textarea
                  value={specialNote}
                  onChange={(e) => setSpecialNote(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg"
                  rows={2}
                  placeholder="Örn: Az pişmiş olsun, soğansız..."
                />
              </div>

              {/* Miktar */}
              <div className="mb-4">
                <h3 className="font-bold mb-2 text-gray-700">Adet</h3>
                <div className="flex items-center space-x-3">
                  <button
                    onClick={() => setCustomQuantity(Math.max(1, customQuantity - 1))}
                    className="w-10 h-10 bg-gray-200 rounded-lg hover:bg-gray-300"
                  >
                    <Minus size={20} className="mx-auto" />
                  </button>
                  <span className="text-2xl font-bold w-12 text-center">{customQuantity}</span>
                  <button
                    onClick={() => setCustomQuantity(customQuantity + 1)}
                    className="w-10 h-10 bg-gray-200 rounded-lg hover:bg-gray-300"
                  >
                    <Plus size={20} className="mx-auto" />
                  </button>
                </div>
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="p-6 border-t bg-gray-50 flex space-x-3">
              <button
                onClick={() => setShowIngredientModal(false)}
                className="flex-1 py-3 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400 font-medium"
              >
                İptal
              </button>
              <button
                onClick={addCustomizedToCart}
                className="flex-1 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-700 font-bold"
              >
                Sepete Ekle
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Gerçek Ödeme Modalı (Ciroya ekleme) */}
      {showFinalPaymentModal && selectedOrderForPayment && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[70] p-4">
          <div className="bg-white rounded-lg w-[500px] max-h-[80vh] flex flex-col">
            <div className="p-6 border-b">
              <h2 className="text-2xl font-bold text-green-700">💰 Ödeme Alın - Ciroya Ekle</h2>
              <p className="text-sm text-gray-600 mt-2">
                Sipariş #{selectedOrderForPayment.id} - {selectedOrderForPayment.customer_name}
              </p>
            </div>

            <div className="p-6 overflow-y-auto flex-1">
              {/* Tutar */}
              <div className="bg-green-50 border-2 border-green-300 rounded-lg p-4 mb-6">
                <div className="text-center">
                  <p className="text-sm text-gray-600 mb-1">Ödenecek Tutar</p>
                  <p className="text-4xl font-bold text-green-700">
                    {selectedOrderForPayment.total.toFixed(2)} ₺
                  </p>
                </div>
              </div>

              {/* Ödeme Yöntemleri */}
              <h3 className="font-bold mb-3">Gerçek Ödeme Yöntemini Seçin:</h3>
              <div className="space-y-3">
                {/* Nakit */}
                <button
                  onClick={() => setPaymentMethod("nakit")}
                  className={`w-full p-4 rounded-lg border-2 transition ${
                    paymentMethod === "nakit"
                      ? "border-green-500 bg-green-50"
                      : "border-gray-200 hover:border-gray-300"
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className="font-bold text-lg">💵 Nakit</span>
                    {paymentMethod === "nakit" && <span className="text-green-600">✓</span>}
                  </div>
                </button>

                {/* Kredi Kartı */}
                <button
                  onClick={() => setPaymentMethod("kredi-karti")}
                  className={`w-full p-4 rounded-lg border-2 transition ${
                    paymentMethod === "kredi-karti"
                      ? "border-blue-500 bg-blue-50"
                      : "border-gray-200 hover:border-gray-300"
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className="font-bold text-lg">💳 Kredi Kartı</span>
                    {paymentMethod === "kredi-karti" && <span className="text-blue-600">✓</span>}
                  </div>
                </button>

                {/* Yemek Kartı */}
                <button
                  onClick={() => setPaymentMethod("yemek-karti")}
                  className={`w-full p-4 rounded-lg border-2 transition ${
                    paymentMethod === "yemek-karti"
                      ? "border-purple-500 bg-purple-50"
                      : "border-gray-200 hover:border-gray-300"
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className="font-bold text-lg">🎫 Yemek Kartı</span>
                    {paymentMethod === "yemek-karti" && <span className="text-purple-600">✓</span>}
                  </div>
                </button>

                {/* Yemek Kartı Alt Seçenekleri */}
                {paymentMethod === "yemek-karti" && (
                  <div className="ml-8 space-y-2 mt-3">
                    {["sodexo", "ticket", "multinet", "metropol"].map(type => (
                      <button
                        key={type}
                        onClick={() => setMealCardType(type)}
                        className={`w-full p-3 rounded-lg border transition text-left ${
                          mealCardType === type
                            ? "border-purple-500 bg-purple-100"
                            : "border-gray-200 hover:border-gray-300 bg-white"
                        }`}
                      >
                        <span className="font-medium capitalize">{type}</span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Footer */}
            <div className="p-6 border-t bg-gray-50 flex space-x-3">
              <button
                onClick={() => setShowFinalPaymentModal(false)}
                className="flex-1 py-3 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400 font-medium"
              >
                İptal
              </button>
              <button
                onClick={completeFinalPayment}
                className="flex-1 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 font-bold"
              >
                ✓ Ödemeyi Tamamla
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Adres Ekleme/Düzenleme Modal */}
      {showAddressModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md m-4">
            <div className="p-6 border-b">
              <h2 className="text-xl font-bold flex items-center">
                <MapPin className="mr-2 text-blue-600" />
                {editingAddress ? 'Adresi Düzenle' : 'Yeni Adres Ekle'}
              </h2>
            </div>

            <div className="p-6 space-y-4">
              {/* Adres Etiketi */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Adres Etiketi (Örn: Ev, İş, Yazlık)
                </label>
                <input
                  type="text"
                  value={newAddress.label}
                  onChange={(e) => setNewAddress({ ...newAddress, label: e.target.value })}
                  placeholder="Ev"
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>

              {/* Adres */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Adres
                </label>
                <textarea
                  value={newAddress.address}
                  onChange={(e) => setNewAddress({ ...newAddress, address: e.target.value })}
                  placeholder="Tam adres bilgisi..."
                  rows={3}
                  className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>

              {/* İsim Soyisim (kayıttan otomatik dolar, zorunlu değil) */}
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">İsim</label>
                  <input
                    type="text"
                    value={newAddress.first_name}
                    onChange={(e) => setNewAddress({ ...newAddress, first_name: e.target.value })}
                    placeholder="(opsiyonel)"
                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Soyisim</label>
                  <input
                    type="text"
                    value={newAddress.last_name}
                    onChange={(e) => setNewAddress({ ...newAddress, last_name: e.target.value })}
                    placeholder="(opsiyonel)"
                    className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>

              {/* Varsayılan Adres */}
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="isDefaultAddress"
                  checked={newAddress.is_default}
                  onChange={(e) => setNewAddress({ ...newAddress, is_default: e.target.checked })}
                  className="mr-2"
                />
                <label htmlFor="isDefaultAddress" className="text-sm text-gray-700">
                  Varsayılan adres olarak ayarla
                </label>
              </div>
            </div>

            {/* Footer */}
            <div className="p-6 border-t bg-gray-50 flex space-x-3">
              <button
                onClick={() => {
                  setShowAddressModal(false);
                  setNewAddress({ label: "", address: "", is_default: false, first_name: customer?.first_name || "", last_name: customer?.last_name || "" });
                  setEditingAddress(null);
                }}
                className="flex-1 py-3 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400 font-medium"
              >
                İptal
              </button>
              <button
                onClick={saveAddress}
                className="flex-1 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium"
              >
                {editingAddress ? 'Güncelle' : 'Kaydet'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PhonePage;
